import React from "react";
import "./GlossaryItem.css";

const GlossaryItem = ({
  title,
  description,
  onClick,
  onClickLike,
  isLiked,
}) => {
  return (
    <div className="glossary-item" onClick={onClick}>
      <button
        className="like-button"
        onClick={onClickLike}
        style={{ opacity: isLiked ? "1" : "0.5" }}
      ></button>

      <div className="glossary-item-title">
        <h4>{title}</h4>
      </div>

      <p>{description}</p>
    </div>
  );
};

export default GlossaryItem;
